import React from 'react';
import styles from './InformationAboutAdvertisementText.module.scss';
import { filedNames } from '../../constants';
import { typeIds } from '../../../../constants/common';

const InformationAboutAdvertisementText = ({ form }) => {
  const { getFieldValue } = form;

  const typeIdValue = getFieldValue(filedNames.typeId);

  const isAdvertisement = typeIds.advertisement === typeIdValue;

  return (
    <>
      {isAdvertisement ? (
        <div className={styles.root}>
          Просим соблюдать требования Закона „О рекламе“. За их нарушение к
          ответственности могут быть привлечены, в том числе, и авторы
          публикаций
        </div>
      ) : (
        <div className={styles.root}>
          В разделе «Информирование» реклама запрещена. Размещение рекламных
          материалов — отдельная услуга с особыми настройками. Для её
          подключения обратитесь в техподдержку:{' '}
          <a href="mailto:support@dispex.ru">support@dispex.ru</a>. Просим
          соблюдать требования Закона „О рекламе“. За их нарушение к
          ответственности могут быть привлечены, в том числе, и авторы
          публикаций
        </div>
      )}
    </>
  );
};

export default InformationAboutAdvertisementText;
